import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/general/user.service';

@Component({
  selector: 'app-user-input',
  templateUrl: './user-input.component.html',
  styleUrls: ['./user-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: UserInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: UserInputComponent,
    },
  ],
})
export class UserInputComponent {
  @Input()
  title = "Select User...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public usersList: Array<CustomSelectOption> = [];

  constructor(
    private userService: UserService,
  ) {
    this.userService
      .all()
      .subscribe((res: Array<User>) => {
        this.usersList = res.map((el) => {
          return {
            name: `${el.first_name} ${el.last_name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.usersList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
